var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap justify-space-between px-2 grid-recipe"},_vm._l((_vm.recipes),function(item){return _c('div',{key:item.id,staticClass:"card-feed mb-4"},[_c('Card3',{attrs:{"type":"ratingShort","recipe":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }